

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const DisclaimerWarrantiesSection = () => {
  return (
    <div>
      <Paragraph>
        TrackBiz is provided on an "as is" and "as available" basis. Provider
        makes no guarantee that TrackBiz will be uninterrupted, error-free,
        completely secure, or available at all times.
      </Paragraph>

      <Alert
        message="No Uptime Guarantee"
        description="Provider will use commercially reasonable efforts to maintain TrackBiz availability, but does not guarantee uninterrupted service or continuous access."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer acknowledges that TrackBiz depends on third-party services,
        vendors, and infrastructure providers that are outside Provider's direct
        control.
      </Paragraph>

      <Paragraph>
        <Text strong>Third-party dependencies may include, but are not limited to:</Text>
      </Paragraph>

      <ul>
        <li>Cloud hosting providers</li>
        <li>Payment processors, including Stripe</li>
        <li>Domain registrars and DNS providers</li>
        <li>Email and notification delivery providers</li>
        <li>Internet service providers</li>
        <li>Customer's own devices, browsers, networks, and hardware</li>
      </ul>

      <Alert
        message="Third-Party Service Interruptions"
        description="Service interruptions, outages, delays, errors, or failures caused by third-party services may affect the availability or functionality of TrackBiz. Provider is not responsible for issues outside its reasonable control."
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Provider does not warrant that TrackBiz will meet every specific business
        requirement, expectation, workflow, reporting need, or operational goal of
        Customer. Customer is responsible for determining whether TrackBiz is
        suitable for Customer's business operations.
      </Paragraph>

      <Paragraph>
        Provider does not guarantee that data transmission over the internet or
        electronic storage will be completely secure. Customer acknowledges that
        no method of electronic transmission, cloud storage, or internet-based
        service can be guaranteed to be one hundred percent secure.
      </Paragraph>

      <Alert
        message="Security Limitations"
        description="Provider will use commercially reasonable safeguards to protect the platform, but cannot guarantee absolute security against all unauthorized access, cyberattacks, service disruptions, or data loss events."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        To the maximum extent permitted by law, Provider disclaims all warranties,
        whether express, implied, statutory, or otherwise, including implied
        warranties of merchantability, fitness for a particular purpose,
        non-infringement, accuracy, reliability, and availability.
      </Paragraph>
    </div>
  );
};

export default DisclaimerWarrantiesSection;